import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from '../../../shared/components';
import layoutStyles from './ReminderEngineLayout.module.css';
import sharedStyles from './reminderEngineShared.module.css';

export const ReminderEngineLayout: React.FC = () => {
  const { t } = useTranslation(['reminderEngine', 'nav']);

  return (
    <div className={sharedStyles.page}>
      <Breadcrumb
        items={[
          { label: t('reminderEngine', { ns: 'nav' }), path: '/reminder-engine/definitions' },
        ]}
      />

      <div className={sharedStyles.headerRow}>
        <div>
          <h2>{t('title')}</h2>
          <p className={sharedStyles.pageIntro}>{t('subtitle')}</p>
        </div>
      </div>

      <nav className={layoutStyles.tabBar} aria-label={t('sectionTabsLabel')}>
        <NavLink
          to="/reminder-engine/definitions"
          className={({ isActive }) => `${layoutStyles.tab} ${isActive ? layoutStyles.tabActive : ''}`}
        >
          {t('definitionsTitle')}
        </NavLink>
        <NavLink
          to="/reminder-engine/templates"
          className={({ isActive }) => `${layoutStyles.tab} ${isActive ? layoutStyles.tabActive : ''}`}
        >
          {t('templatesTitle')}
        </NavLink>
        <NavLink
          to="/reminder-engine/scheduled"
          className={({ isActive }) => `${layoutStyles.tab} ${isActive ? layoutStyles.tabActive : ''}`}
        >
          {t('scheduledTitle')}
        </NavLink>
      </nav>

      <div className={layoutStyles.tabPanel}>
        <Outlet />
      </div>
    </div>
  );
};
